<template>
  <div class="solution" v-if="selectedSolution">
    <div class="breadcrumbs-wrapper">
      <div class="breadcrumbs">
        <a class="breadcrumbs-back" @click="$router.go(-1)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.733 10">
            <defs></defs>
            <g transform="translate(-100 -124)">
              <path
                class="a"
                d="M-9.61-18.131l-4.215-4.563A.375.375,0,0,1-14-23.031a.374.374,0,0,1,.175-.336l4.215-4.524a.42.42,0,0,1,.549-.039.419.419,0,0,1,.039.548L-12.7-23.423H8.341a.37.37,0,0,1,.392.392.37.37,0,0,1-.392.392H-12.695l3.672,3.958a.353.353,0,0,1-.039.549.357.357,0,0,1-.274.118A.356.356,0,0,1-9.61-18.131Z"
                transform="translate(114 152.014)"
              ></path>
            </g>
          </svg>
        </a>
        <router-link class="breadcrumbs-item" :to="`/${selectedSolution.category}`">
          <span v-if="this.$route.params.category === 'industrial'">Индустриални</span>
          <span v-if="this.$route.params.category === 'administrative'">Административни</span>
          <span v-if="this.$route.params.category === 'trade'">Търговия</span>
          <span v-if="this.$route.params.category === 'financial'">Финансови</span>
          <span v-if="this.$route.params.category === 'business'">Бизнес</span>
          <span v-if="this.$route.params.category === 'medicine'">Медицина</span>
          <!-- <span v-if="this.$route.params.category === 'e-commerce'">E-магазини</span> -->
          <span v-if="this.$route.params.category === 'integration'">Интеграция</span>
          <span v-if="this.$route.params.category === 'others'">Други</span>
        </router-link>
        <span class="breadcrumbs-splitter">&gt;</span>
        <p class="breadcrumbs-last">{{selectedSolution.name[0]}}</p>
      </div>
    </div>
    <div class="solution-header">
      <div class="solution-header-left">
        <h2>{{selectedSolution.name[1]}}</h2>
        <p>{{selectedSolution.company}}</p>
      </div>
      <img class="solution-img" :src="selectedSolution.imageTwo" alt="Image">
    </div>
    <div class="solution-descriptions">
      <div class="inquiry-btns">
        <a class="inquiry-btn" @click="isInquiryOpened = true">Запитване</a>
        <a href="tel:+359889799988" class="inquiry-btn">0889799988</a>
      </div>
      <p
        class="solution-descriptions-p"
        v-for="(text, index) in selectedSolution.texts"
        :key="`description-${index}`"
        v-html="text"
      ></p>
    </div>
    <SolutionInquiry v-if="isInquiryOpened" :solution="`${selectedSolution.name[0]}`"/>
  </div>
</template>

<script>
import Solutions from "../assets/solutions.json";
import SolutionInquiry from "./SolutionInquiry";
export default {
  components: {
    SolutionInquiry
  },
  data() {
    return {
      solutions: Solutions,
      selectedSolution: undefined,
      isInquiryOpened: false
    };
  },
  watch: {
    // search again for solution on route change if still in this component
    $route(to, from) {
      this.findSolution();
    }
  },
  methods: {
    findSolution() {
      this.selectedSolution = this.solutions.filter(o => {
        return (
          o.url === this.$route.params.solution &&
          o.category === this.$route.params.category
        );
      })[0];
    }
  },
  mounted() {
    // find the solution on init
    this.findSolution();

    this.$on("close-inquiry", () => {
      this.isInquiryOpened = false;
    });
  },
  destroyed() {
    this.$off("close-inquiry");
  }
};
</script>

<style scoped>
.solution {
  display: flex;
  flex-direction: column;
  /* max-height: calc(100vh - 100px); */
}
.breadcrumbs-wrapper {
  align-items: center;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 99px 0px rgba(0, 0, 0, 0.29);
  -moz-box-shadow: 0px 0px 99px 0px rgba(0, 0, 0, 0.29);
  box-shadow: 0px 0px 99px 0px rgba(0, 0, 0, 0.29);
  display: flex;
  height: 60px;
  min-height: 60px;
  justify-content: space-between;
  padding: 0 100px;
  width: 100%;
}
.breadcrumbs {
  align-items: center;
  display: flex;
}
.breadcrumbs-back {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  margin-right: 10px;
  width: 40px;
}
.breadcrumbs-back > svg {
  color: #191b1d;
  width: 23px;
}
.breadcrumbs-item {
  color: rgba(14, 22, 26, 0.8);
  font-size: 20px;
  font-weight: 700;
}
.breadcrumbs-item:hover {
  color: rgba(14, 22, 26, 0.7);
}
.breadcrumbs-last {
  color: rgba(14, 22, 26, 0.8);
  font-size: 20px;
  font-weight: 700;
}
.breadcrumbs-splitter {
  color: rgba(14, 22, 26, 0.8);
  font-size: 20px;
  font-weight: 700;
  margin: 0 20px;
}
.solution-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  /* *** */
  /* IE FIX */
  min-height: 1px;
  /* IE FIX */
  /* *** */
  padding: 60px 100px;
}
.solution-header-left {
  width: 65%;
}
.solution-header-left h2 {
  color: rgba(0, 0, 0, 0.8);
}
.solution-header-left p {
  color: rgba(0, 0, 0, 0.8);
  font-size: 26px;
  margin-top: 10px;
}
.solution-img {
  position: relative;
  display: inline-block;
  width: 37%;
  z-index: 1;
}
/* DESCRIPTIONS */
.solution-descriptions {
  padding: 0 100px 50px;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ebe8e8+50,f0f0f0+100 */
  background: rgb(255, 255, 255);
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f0f0f0',GradientType=0 );
}
.inquiry-btn {
  align-items: center;
  background-color: #000;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  width: 178px;
  transform: translateY(-50%);
}
.inquiry-btn:hover {
  background-color: #191b1d;
}
.solution-descriptions-p {
  color: #000;
  font-size: 20px;
  line-height: 26px;
  padding: 20px 0 20px 178px;
  position: relative;
}
.solution-descriptions-p::before {
  background-color: #707070;
  border-radius: 50%;
  content: "";
  height: 27px;
  left: 75.5px;
  position: absolute;
  top: 20px;
  width: 27px;
}
.solution-descriptions-p::after {
  background-color: #707070;
  content: "";
  height: 100%;
  left: 89px;
  position: absolute;
  top: 33.5px;
  width: 1px;
}
/* .solution-descriptions-p:last-of-type {
  color: #5b5b5b;
} */
.solution-descriptions-p:last-of-type::after {
  display: none;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .solution-descriptions-p {
    font-size: 16px;
  }
  .breadcrumbs-item,
  .breadcrumbs-last,
  .inquiry-btn {
    font-size: 16px;
  }
  .solution-header-left p {
    font-size: 24px;
  }
}
@media screen and (max-width: 1440px) {
  .solution-descriptions-p {
    font-size: 14px;
    line-height: 16px;
    padding: 15px 0 15px 178px;
  }
  .solution-header-left p {
    font-size: 18px;
  }
  .solution-descriptions-p {
    font-size: 14px;
  }
  .breadcrumbs-item,
  .breadcrumbs-last,
  .inquiry-btn {
    font-size: 14px;
  }
}
@media screen and (max-width: 1366px) {
  .solution-header-left p {
    font-size: 14px;
  }
  .inquiry-btn {
    height: 40px;
    width: 150px;
  }
  .solution-descriptions-p::before {
    height: 20px;
    width: 20px;
  }
  .solution-descriptions-p::after {
    left: 85.5px;
  }
}
@media screen and (max-width: 1280px) {
  .solution {
    max-height: initial;
  }
  .breadcrumbs-item,
  .breadcrumbs-splitter {
    display: none;
  }
  .breadcrumbs-wrapper {
    padding: 0 20px;
  }
  .solution-header {
    justify-content: center;
    padding: 50px 20px;
  }
  .solution-header-left {
    display: none;
  }
  .solution-img {
    width: 50%;
  }
  .solution-descriptions {
    padding: 50px 20px;
    position: relative;
  }
  .inquiry-btns {
    display: flex;
    left: 50%;
    position: absolute;
    top: 0;
    transform: translateY(-50%) translateX(-50%);
  }
  .inquiry-btn:first-child {
    margin-right: 5px;
  }
  .inquiry-btn {
    transform: initial;
  }
}
@media screen and (max-width: 1000px) {
  .solution-descriptions {
    padding-bottom: 100px;
  }
}
@media screen and (max-width: 600px) {
  .solution-descriptions-p {
    padding: 15px 0 15px 50px;
  }
  .solution-descriptions-p::before {
    height: 20px;
    left: 5px;
    width: 20px;
  }
  .solution-descriptions-p::after {
    left: 14.5px;
  }
  .solution-descriptions {
    padding-bottom: 87px;
  }
}

@media screen and (max-width: 420px) {
  .inquiry-btn {
    width: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Solution.vue